import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appInputTrim]'
})
export class InputTrimDirective {
  constructor(private control : NgControl){}
  @HostListener('input', ['$event'])
  onKeyDown(event: KeyboardEvent) {
   
    const input = event.target as HTMLInputElement;
    if(input.value.trim().length){
     // this.control.control?.setValue(input?.value.trim())
      //input.value = input?.value.trim();
      this.control.control?.updateValueAndValidity();
    }else{
      this.control.control?.setValue(input?.value.trim());
      this.control.control?.updateValueAndValidity();
    }
    
  }
}
